import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Grid } from '@mui/material';
import { DashboardLayout } from '@blumtechgroup/blum-react-core-components';
import EditDansFundQuestionnaireComponent
  from '../../../../components/Global/DansFundQuestionnaire/Edit';

const EditDansFundQuestionnaire = (): React.ReactElement => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  const handleFinish = () => {
    navigate(`/admin/dans-fund-questionnaire`);
  };

  const questionnaireId = id || '';

  return (
    <DashboardLayout breadcrumbs={[
      { label: 'Admin', link: '/admin/home' },
      {
        label: 'Dan\'s Fund Questionnaire',
        link: '/admin/dans-fund-questionnaire',
      },
      { label: 'Edit' },
    ]}>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <EditDansFundQuestionnaireComponent questionnaireId={questionnaireId}
                                              handleFinish={handleFinish} />
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};

export default EditDansFundQuestionnaire;
